import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=22d1fd72&scoped=true"
import script from "./Input.ts?vue&type=script&lang=ts&external"
export * from "./Input.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d1fd72",
  null
  
)

export default component.exports